/** @format */

import React from "react";
import {
    Container,
    Row,
    Col,
    Form,
    Input,
    InputGroupAddon,
    InputGroup,
    Button,
    Collapse,
} from "reactstrap";

import data from "../data/login-footer.json";

import Icon from "./Icon";

const LoginFooter = () => {
    const [columnOpen, setColumnOpen] = React.useState({}); //For mobile devices, we show toggle for hide/show menu

    const toggleColumn = (e, name) => {
        e.preventDefault()
        setColumnOpen({ ...columnOpen, [name]: !columnOpen[name] })
    }

    return (
        <footer>
            <div className="background123">
                <div className="py-6 text-muted">
                    <Container>
                        <Row>
                            <Col lg="5" md="12" className="pr-lg-5 pr-xl-6 mb-5 mb-lg-0 text-center">

                                <div className="logo123">
                                    <img src="/footer-logo.png" alt="" />
                                </div>



                            </Col>
                            <Col lg="7">
                                <Row>
                                    {data.columns.map(column =>
                                        <Col key={column.name} lg="4">
                                            <a href="javasc" className="d-lg-none block-toggler my-3" aria-expanded={columnOpen[column.name]} onClick={(e) => toggleColumn(e, column.name)}>{column.name}<span className="block-toggler-icon"></span></a>
                                            <Collapse isOpen={columnOpen[column.name]} className="expand-lg">
                                                <h6 className="text-dark letter-spacing-1 mb-4 d-none d-lg-block">{column.name}</h6>
                                                <ul className="list-unstyled text-sm pt-2 pt-lg-0">
                                                    {column.links.map(link =>
                                                        <li key={link.name} className="mb-2 drop123">
                                                            {/*  {link.hasLink &&
                                                                (
                                                                    <a href={link.link} target={link.open ? "_blank" : ""}>
                                                                        <a className=" drop3" >{link.name}</a>
                                                                    </a>
                                                                )} */}
                                                            {link.hasLink &&
                                                                (
                                                                    <a className=" drop3" href={link.link} target={link.open ? "_blank" : ""}>
                                                                        {link.name}
                                                                    </a>
                                                                )}
                                                            {!link.hasLink && (<p style={{ color: "#adb5bd" }}>{link.name}</p>)}

                                                        </li>
                                                    )}
                                                </ul>
                                            </Collapse>
                                        </Col>
                                    )}
                                </Row>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <div className="py-4 font-weight-light text-muted">
                    <Container>
                        <Row className="align-items-center text-sm text-gray-500 pl-lg-5">
                            <Col lg="12" className="text-center">
                                <p className="mb-lg-0">&copy; {new Date().getFullYear()} All rights reserved. Brooklyn Bicycle Co.</p>
                            </Col>

                        </Row>
                    </Container>
                </div>
            </div>
        </footer>
    )
};

export default LoginFooter;
